"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapObject = void 0;
var tslib_1 = require("tslib");
function mapObject(obj, fn) {
    var mapped = Object.entries(obj).map(
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    function (_a) {
        var _b;
        var _c = tslib_1.__read(_a, 2), key = _c[0], value = _c[1];
        return (_b = {}, _b[key] = fn(value, key), _b);
    });
    return Object.assign.apply(Object, tslib_1.__spread([{}], mapped));
}
exports.mapObject = mapObject;
//# sourceMappingURL=mapObject.js.map